<template>
  <div class="button-wrapper">
    <vs-button
      :href="data.link"
      block
      :border="!data.featured"
      :blank="data.blank"
    >
      <i class="bx" :class="data.iconClass"></i> {{ data.text }}
    </vs-button>
  </div>
</template>

<script>
export default {
  name: "Button",
  props: ["data"]
};
</script>

<style scoped>
.button-wrapper:not(:last-of-type) {
  margin-bottom: 10px;
}
.vs-button {
  margin-left: auto;
}
.vs-button i {
  padding-right: 5px;
}
</style>
